export default __webpack_public_path__ + "static/media/Group -65@2x.383363b0.png";